import React, { useEffect, useState } from "react";
import { Routes, Route } from "react-router-dom";
import { quotation } from "./quotation";
import { estimate } from "./estimate";
import Main from "../pages/main";
import PostPurchase from "../pages/postpurchase";
import MedicalAssessmentForm from "../pages/bookappointment";
import PaymentGateway from "../components/payment_gateway";
import { useSelector, useDispatch } from "react-redux";
import { authenticate } from "../store/policy";
import PrivateRoute from "../PrivateRoute";

function Index() {
  const dispatch = useDispatch();
  const { isAuthenticated } = useSelector((state) => state.policySlice);

  useEffect(() => {
    authenticate();
  }, []);

  return (
    <Routes>
      <Route path="/" element={<Main />} />
      {estimate}
      {quotation}
      <Route path="/postpurchase" element={<PrivateRoute><PostPurchase /></PrivateRoute>} />
      <Route path="/bookassessment" element={<PrivateRoute><MedicalAssessmentForm /></PrivateRoute>} />
      <Route path="/payment-gateway" element={<PrivateRoute><PaymentGateway/></PrivateRoute>}/>
    </Routes>
  );
}

export default Index;
